import { render } from "./Diff.vue?vue&type=template&id=4674a76e&scoped=true"
import script from "./Diff.vue?vue&type=script&lang=js"
export * from "./Diff.vue?vue&type=script&lang=js"

import "./Diff.vue?vue&type=style&index=0&id=4674a76e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4674a76e"]])

export default __exports__